import type { User } from '@/types/api';

/**
 * Prüft ob der User eine Permission hat. Permissions kommen als flaches
 * Objekt von `/user/me` – Beispiele: acc_kurse_r, acc_kurse_w, is_admin.
 */
export function hasPermission(user: User | null | undefined, perm: string): boolean {
  if (!user?.permissions) return false;
  return Boolean(user.permissions[perm]);
}

export function isAdmin(user: User | null | undefined): boolean {
  return hasPermission(user, 'is_admin');
}

export function isAdminX(user: User | null | undefined): boolean {
  return hasPermission(user, 'is_admin_x');
}

export function isKisproEmployee(user: User | null | undefined): boolean {
  return Boolean(user?.is_kispro_employee);
}
